import { Component } from '@angular/core';

@Component({
  selector: 'web-foodis-section-reports',
  templateUrl: './section-reports.component.html',
  styleUrls: ['./section-reports.component.scss'],
})
export class SectionReportsComponent {}
